<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <v-icon large left>mdi-calendar</v-icon>
        <span class="title font-weight-light">Đơn Mượn: {{book.name}}</span>
      </v-card-title>
      <v-card-text>
        <book-new-form ref="form" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed @click="cancel">Hủy</v-btn>
        <v-btn small depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BookNewForm from '@/components/basic/form/BookAssignForm.vue'

export default {
  components: { BookNewForm },
  props: {
    book: Object,
    state: Boolean
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions('books', ['fetchBooks', 'createBook', 'updateBook']),
    async save () {
      const data = this.$refs.form.getData()
      await this.updateBook({
        ...data,
        id: this.book.id
      })
      this.dialog = false
      this.reset()
    },

    cancel () {
      this.reset()
      this.$emit('cancel')
      this.dialog = false
    },
    reset () {
      this.$refs.form.reset()
    }
  },
  created () {
    this.fetchBooks()
  },
  computed: {
    ...mapGetters('books', ['books']),
    ...mapGetters('app', ['department'])
  },
  watch: {
    state (state) {
      this.dialog = true
    }
  }
}
</script>
<style scoped>
</style>
